/* eslint-disable prettier/prettier */
import localize from '../localize';

const defaultFilters = [
  {
    key: 'servicecategory',
    position: 'top',
    attribute: 'taxonomies.servicecategory',
    copyKey: 'ServiceGroupLabel',
    copySelect: 'ServiceGroupPlaceholder',
    isBoxDisplay: localize('showServiceGroupyBox') ? false : true,
  },
  {
    key: 'serviceregion',
    position: 'top',
    attribute: 'taxonomies.serviceregion',
    copyKey: 'CountyLabel',
    copySelect: 'CountyPlaceholder',
    isBoxDisplay: localize('showCountyBox') ? false : true,
  },
  {
    key: 'role',
    position: 'top',
    attribute: 'taxonomies.role',
    copyKey: 'RollerLabel',
    copySelect: 'RollerPlaceholder',
    isBoxDisplay: localize('showRollerBox') ? false : true,
  },
  {
    key: 'search',
    position: 'top',
    copyKey: 'Searchlabel',
    copyPlaceholder: 'Searchplaceholder',
    isBoxDisplay: localize('showSearchBox') ? false : true,
  },
];

var exportedFilters = defaultFilters;

export default exportedFilters;
